module.exports = __webpack_public_path__ + "img/activity7.a97e1451.png";